/** Super admin auth — separate from CRM permissions.js */

export const USER_TYPE_SUPER_ADMIN = 'Super Admin';

export function isSuperAdminUser(user) {
  if (!user) return false;
  if (user.isSuperAdmin === true) return true;
  if (String(user.accountType ?? '').toLowerCase() === 'super_admin') return true;
  const role = String(user.role ?? '').toLowerCase();
  if (role === 'super_admin') return true;
  return String(user.userType ?? user.user_type ?? '').trim().toLowerCase() === USER_TYPE_SUPER_ADMIN.toLowerCase();
}

export function getStoredUser() {
  try {
    const raw = localStorage.getItem('user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/** New Google sign-ups must add a mobile number before using the CRM. */
export function needsPhoneSetup(user) {
  return !!user && !isSuperAdminUser(user) && (user.phoneSetupRequired === true || user.phoneSetupRequired === 1);
}

export function getPostLoginPath(user) {
  if (isSuperAdminUser(user)) return '/super-admin/dashboard';
  return needsPhoneSetup(user) ? '/complete-profile' : '/dashboard';
}

export function getAuthToken() {
  return localStorage.getItem('token');
}

export function setStoredUser(user) {
  if (user && typeof user === 'object') {
    localStorage.setItem('user', JSON.stringify(user));
    window.dispatchEvent(new CustomEvent('user-updated', { detail: user }));
  }
}
